import {ChartData, ChartOptions,} from 'chart.js';
import 'chartjs-adapter-date-fns';
import {useEffect, useState} from "react";
import {Chart, ChartProps} from '../Chart/Chart';
import {useTranslation} from "react-i18next";
import {TFunction} from "i18next";
import {useMantineTheme} from "@mantine/core";
import {MantineTheme} from "@mantine/styles/lib/theme";
import {LayoutPosition} from "chart.js/dist/types/layout";

export type PieChartData = {
  name: string
  value: number
}

export type PieChartProps = Omit<ChartProps<'pie'>, 'type' | 'options' | 'data'> & {
  data?: PieChartData[]
  tooltipPos?: LayoutPosition
};

export const PieChart = (props: PieChartProps) => {
  const {
    data,
    tooltipPos,
    ...rest
  } = props;

  const theme = useMantineTheme();

  const {t,} = useTranslation(["common"])

  const [chartOptions, setChartOptions] = useState<
    ChartOptions<'pie'> | undefined
  >(undefined);

  const [chartData, setChartData] = useState<
    ChartData<'pie'> | undefined
  >(undefined);

  useEffect(() => {
    setChartOptions(getChartOptions(tooltipPos))
  }, [t, tooltipPos])

  useEffect(() => {
    setChartData(getChartData(data, theme, t))
  }, [data, t, theme])

  return <Chart {...rest} type="pie" options={chartOptions} data={chartData}/>
};


const getChartOptions = (tooltipPos: LayoutPosition | undefined): ChartOptions<'pie'> => {
  return {
    maintainAspectRatio: false,
    animation: false,
    responsive: true,
    plugins: {
      legend: {
        position: tooltipPos ?? 'top',
      },
      datalabels: {
        display: false
      },
      tooltip: {
        callbacks: {
          footer: (tooltipItems) => {
            let sum = 0;
            const dataArr = tooltipItems[0].dataset.data;
            dataArr.forEach(data => {
              sum += Number(data);
            });

            const value = tooltipItems[0].parsed;

            return (value * 100 / sum).toFixed(2) + "%";
          },
        }
      },
    },
  };
};

const getChartData = (data: PieChartData[] | undefined, theme: MantineTheme, t: TFunction<"common"[], any, "common"[]>): ChartData<'pie'> => {
  return {
    labels: data?.map(d => d.name),
    datasets: [{
      data: data ? data.map((d) => d.value) : []
    }],
  };
};
